import { render, staticRenderFns } from "./inspectionOfCertifiedPhotos.vue?vue&type=template&id=50b3e1bf&scoped=true"
import script from "./inspectionOfCertifiedPhotos.vue?vue&type=script&lang=js"
export * from "./inspectionOfCertifiedPhotos.vue?vue&type=script&lang=js"
import style0 from "./inspectionOfCertifiedPhotos.vue?vue&type=style&index=0&id=50b3e1bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3e1bf",
  null
  
)

export default component.exports